/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AddAssetsToCollectionDto,
  CollectionAssetsResponseDto,
  CreateCollectionDto,
  CreateGifFromAssetsDto,
  GetAssetsResponseDto,
  GetCollectionsResponseDto,
  ImportAssetFromUrlDto,
  MediaAssetDto,
  MediaCollectionDto,
  MediaLibraryControllerGetAssetsParams,
  MediaLibraryControllerUploadAssetBody,
  RemoveBackgroundDto,
  RemoveBackgroundResponseDto,
  SuccessResponseDto,
  UpdateAssetDto,
  UpdateCollectionDto,
  VectorizeImageDto,
  VectorizeImageResponseDto,
} from '.././models';

import { authFetch } from '../../../../lib/api';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get all media assets for a client
 */
export const mediaLibraryControllerGetAssets = (
  orgId: string,
  clientId: string,
  params?: MediaLibraryControllerGetAssetsParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<GetAssetsResponseDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}/media/assets`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getMediaLibraryControllerGetAssetsQueryKey = (
  orgId?: string,
  clientId?: string,
  params?: MediaLibraryControllerGetAssetsParams
) => {
  return [
    `/api/organizations/${orgId}/clients/${clientId}/media/assets`,
    ...(params ? [params] : []),
  ] as const;
};

export const getMediaLibraryControllerGetAssetsQueryOptions = <
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetAssets>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: MediaLibraryControllerGetAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof mediaLibraryControllerGetAssets>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMediaLibraryControllerGetAssetsQueryKey(orgId, clientId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaLibraryControllerGetAssets>>> = ({
    signal,
  }) => mediaLibraryControllerGetAssets(orgId, clientId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof mediaLibraryControllerGetAssets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MediaLibraryControllerGetAssetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof mediaLibraryControllerGetAssets>>
>;
export type MediaLibraryControllerGetAssetsQueryError = unknown;

export function useMediaLibraryControllerGetAssets<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetAssets>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params: undefined | MediaLibraryControllerGetAssetsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof mediaLibraryControllerGetAssets>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaLibraryControllerGetAssets>>,
          TError,
          Awaited<ReturnType<typeof mediaLibraryControllerGetAssets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMediaLibraryControllerGetAssets<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetAssets>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: MediaLibraryControllerGetAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof mediaLibraryControllerGetAssets>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaLibraryControllerGetAssets>>,
          TError,
          Awaited<ReturnType<typeof mediaLibraryControllerGetAssets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMediaLibraryControllerGetAssets<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetAssets>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: MediaLibraryControllerGetAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof mediaLibraryControllerGetAssets>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get all media assets for a client
 */

export function useMediaLibraryControllerGetAssets<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetAssets>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: MediaLibraryControllerGetAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof mediaLibraryControllerGetAssets>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMediaLibraryControllerGetAssetsQueryOptions(
    orgId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a single media asset
 */
export const mediaLibraryControllerGetAsset = (
  orgId: string,
  clientId: string,
  id: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MediaAssetDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}/media/assets/${id}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getMediaLibraryControllerGetAssetQueryKey = (
  orgId?: string,
  clientId?: string,
  id?: string
) => {
  return [`/api/organizations/${orgId}/clients/${clientId}/media/assets/${id}`] as const;
};

export const getMediaLibraryControllerGetAssetQueryOptions = <
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetAsset>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof mediaLibraryControllerGetAsset>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMediaLibraryControllerGetAssetQueryKey(orgId, clientId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaLibraryControllerGetAsset>>> = ({
    signal,
  }) => mediaLibraryControllerGetAsset(orgId, clientId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && clientId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof mediaLibraryControllerGetAsset>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MediaLibraryControllerGetAssetQueryResult = NonNullable<
  Awaited<ReturnType<typeof mediaLibraryControllerGetAsset>>
>;
export type MediaLibraryControllerGetAssetQueryError = unknown;

export function useMediaLibraryControllerGetAsset<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetAsset>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof mediaLibraryControllerGetAsset>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaLibraryControllerGetAsset>>,
          TError,
          Awaited<ReturnType<typeof mediaLibraryControllerGetAsset>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMediaLibraryControllerGetAsset<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetAsset>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof mediaLibraryControllerGetAsset>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaLibraryControllerGetAsset>>,
          TError,
          Awaited<ReturnType<typeof mediaLibraryControllerGetAsset>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMediaLibraryControllerGetAsset<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetAsset>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof mediaLibraryControllerGetAsset>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single media asset
 */

export function useMediaLibraryControllerGetAsset<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetAsset>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof mediaLibraryControllerGetAsset>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMediaLibraryControllerGetAssetQueryOptions(orgId, clientId, id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update media asset metadata
 */
export const mediaLibraryControllerUpdateAsset = (
  orgId: string,
  clientId: string,
  id: string,
  updateAssetDto: UpdateAssetDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<MediaAssetDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}/media/assets/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateAssetDto,
    },
    options
  );
};

export const getMediaLibraryControllerUpdateAssetMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mediaLibraryControllerUpdateAsset>>,
    TError,
    { orgId: string; clientId: string; id: string; data: UpdateAssetDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mediaLibraryControllerUpdateAsset>>,
  TError,
  { orgId: string; clientId: string; id: string; data: UpdateAssetDto },
  TContext
> => {
  const mutationKey = ['mediaLibraryControllerUpdateAsset'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mediaLibraryControllerUpdateAsset>>,
    { orgId: string; clientId: string; id: string; data: UpdateAssetDto }
  > = (props) => {
    const { orgId, clientId, id, data } = props ?? {};

    return mediaLibraryControllerUpdateAsset(orgId, clientId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MediaLibraryControllerUpdateAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof mediaLibraryControllerUpdateAsset>>
>;
export type MediaLibraryControllerUpdateAssetMutationBody = UpdateAssetDto;
export type MediaLibraryControllerUpdateAssetMutationError = unknown;

/**
 * @summary Update media asset metadata
 */
export const useMediaLibraryControllerUpdateAsset = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mediaLibraryControllerUpdateAsset>>,
      TError,
      { orgId: string; clientId: string; id: string; data: UpdateAssetDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mediaLibraryControllerUpdateAsset>>,
  TError,
  { orgId: string; clientId: string; id: string; data: UpdateAssetDto },
  TContext
> => {
  const mutationOptions = getMediaLibraryControllerUpdateAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete media asset (soft delete)
 */
export const mediaLibraryControllerDeleteAsset = (
  orgId: string,
  clientId: string,
  id: string,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<SuccessResponseDto>(
    { url: `/api/organizations/${orgId}/clients/${clientId}/media/assets/${id}`, method: 'DELETE' },
    options
  );
};

export const getMediaLibraryControllerDeleteAssetMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mediaLibraryControllerDeleteAsset>>,
    TError,
    { orgId: string; clientId: string; id: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mediaLibraryControllerDeleteAsset>>,
  TError,
  { orgId: string; clientId: string; id: string },
  TContext
> => {
  const mutationKey = ['mediaLibraryControllerDeleteAsset'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mediaLibraryControllerDeleteAsset>>,
    { orgId: string; clientId: string; id: string }
  > = (props) => {
    const { orgId, clientId, id } = props ?? {};

    return mediaLibraryControllerDeleteAsset(orgId, clientId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MediaLibraryControllerDeleteAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof mediaLibraryControllerDeleteAsset>>
>;

export type MediaLibraryControllerDeleteAssetMutationError = unknown;

/**
 * @summary Delete media asset (soft delete)
 */
export const useMediaLibraryControllerDeleteAsset = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mediaLibraryControllerDeleteAsset>>,
      TError,
      { orgId: string; clientId: string; id: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mediaLibraryControllerDeleteAsset>>,
  TError,
  { orgId: string; clientId: string; id: string },
  TContext
> => {
  const mutationOptions = getMediaLibraryControllerDeleteAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Upload a new media asset
 */
export const mediaLibraryControllerUploadAsset = (
  orgId: string,
  clientId: string,
  mediaLibraryControllerUploadAssetBody: MediaLibraryControllerUploadAssetBody,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  if (mediaLibraryControllerUploadAssetBody.file !== undefined) {
    formData.append(`file`, mediaLibraryControllerUploadAssetBody.file);
  }
  if (mediaLibraryControllerUploadAssetBody.title !== undefined) {
    formData.append(`title`, mediaLibraryControllerUploadAssetBody.title);
  }
  if (mediaLibraryControllerUploadAssetBody.description !== undefined) {
    formData.append(`description`, mediaLibraryControllerUploadAssetBody.description);
  }
  if (mediaLibraryControllerUploadAssetBody.altText !== undefined) {
    formData.append(`altText`, mediaLibraryControllerUploadAssetBody.altText);
  }
  if (mediaLibraryControllerUploadAssetBody.category !== undefined) {
    formData.append(`category`, mediaLibraryControllerUploadAssetBody.category);
  }
  if (mediaLibraryControllerUploadAssetBody.tags !== undefined) {
    mediaLibraryControllerUploadAssetBody.tags.forEach((value) => formData.append(`tags`, value));
  }
  if (mediaLibraryControllerUploadAssetBody.metadata !== undefined) {
    formData.append(`metadata`, mediaLibraryControllerUploadAssetBody.metadata);
  }
  if (mediaLibraryControllerUploadAssetBody.sourceLinkUrl !== undefined) {
    formData.append(`sourceLinkUrl`, mediaLibraryControllerUploadAssetBody.sourceLinkUrl);
  }

  return authFetch<MediaAssetDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}/media/assets/upload`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options
  );
};

export const getMediaLibraryControllerUploadAssetMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mediaLibraryControllerUploadAsset>>,
    TError,
    { orgId: string; clientId: string; data: MediaLibraryControllerUploadAssetBody },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mediaLibraryControllerUploadAsset>>,
  TError,
  { orgId: string; clientId: string; data: MediaLibraryControllerUploadAssetBody },
  TContext
> => {
  const mutationKey = ['mediaLibraryControllerUploadAsset'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mediaLibraryControllerUploadAsset>>,
    { orgId: string; clientId: string; data: MediaLibraryControllerUploadAssetBody }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return mediaLibraryControllerUploadAsset(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MediaLibraryControllerUploadAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof mediaLibraryControllerUploadAsset>>
>;
export type MediaLibraryControllerUploadAssetMutationBody = MediaLibraryControllerUploadAssetBody;
export type MediaLibraryControllerUploadAssetMutationError = unknown;

/**
 * @summary Upload a new media asset
 */
export const useMediaLibraryControllerUploadAsset = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mediaLibraryControllerUploadAsset>>,
      TError,
      { orgId: string; clientId: string; data: MediaLibraryControllerUploadAssetBody },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mediaLibraryControllerUploadAsset>>,
  TError,
  { orgId: string; clientId: string; data: MediaLibraryControllerUploadAssetBody },
  TContext
> => {
  const mutationOptions = getMediaLibraryControllerUploadAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Import a media asset from an external URL
 */
export const mediaLibraryControllerImportAssetFromUrl = (
  orgId: string,
  clientId: string,
  importAssetFromUrlDto: ImportAssetFromUrlDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MediaAssetDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}/media/assets/import-url`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: importAssetFromUrlDto,
      signal,
    },
    options
  );
};

export const getMediaLibraryControllerImportAssetFromUrlMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mediaLibraryControllerImportAssetFromUrl>>,
    TError,
    { orgId: string; clientId: string; data: ImportAssetFromUrlDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mediaLibraryControllerImportAssetFromUrl>>,
  TError,
  { orgId: string; clientId: string; data: ImportAssetFromUrlDto },
  TContext
> => {
  const mutationKey = ['mediaLibraryControllerImportAssetFromUrl'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mediaLibraryControllerImportAssetFromUrl>>,
    { orgId: string; clientId: string; data: ImportAssetFromUrlDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return mediaLibraryControllerImportAssetFromUrl(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MediaLibraryControllerImportAssetFromUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof mediaLibraryControllerImportAssetFromUrl>>
>;
export type MediaLibraryControllerImportAssetFromUrlMutationBody = ImportAssetFromUrlDto;
export type MediaLibraryControllerImportAssetFromUrlMutationError = unknown;

/**
 * @summary Import a media asset from an external URL
 */
export const useMediaLibraryControllerImportAssetFromUrl = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mediaLibraryControllerImportAssetFromUrl>>,
      TError,
      { orgId: string; clientId: string; data: ImportAssetFromUrlDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mediaLibraryControllerImportAssetFromUrl>>,
  TError,
  { orgId: string; clientId: string; data: ImportAssetFromUrlDto },
  TContext
> => {
  const mutationOptions = getMediaLibraryControllerImportAssetFromUrlMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Create an animated GIF from multiple media assets
 */
export const mediaLibraryControllerCreateGifFromAssets = (
  orgId: string,
  clientId: string,
  createGifFromAssetsDto: CreateGifFromAssetsDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MediaAssetDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}/media/assets/create-gif`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createGifFromAssetsDto,
      signal,
    },
    options
  );
};

export const getMediaLibraryControllerCreateGifFromAssetsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mediaLibraryControllerCreateGifFromAssets>>,
    TError,
    { orgId: string; clientId: string; data: CreateGifFromAssetsDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mediaLibraryControllerCreateGifFromAssets>>,
  TError,
  { orgId: string; clientId: string; data: CreateGifFromAssetsDto },
  TContext
> => {
  const mutationKey = ['mediaLibraryControllerCreateGifFromAssets'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mediaLibraryControllerCreateGifFromAssets>>,
    { orgId: string; clientId: string; data: CreateGifFromAssetsDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return mediaLibraryControllerCreateGifFromAssets(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MediaLibraryControllerCreateGifFromAssetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof mediaLibraryControllerCreateGifFromAssets>>
>;
export type MediaLibraryControllerCreateGifFromAssetsMutationBody = CreateGifFromAssetsDto;
export type MediaLibraryControllerCreateGifFromAssetsMutationError = unknown;

/**
 * @summary Create an animated GIF from multiple media assets
 */
export const useMediaLibraryControllerCreateGifFromAssets = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mediaLibraryControllerCreateGifFromAssets>>,
      TError,
      { orgId: string; clientId: string; data: CreateGifFromAssetsDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mediaLibraryControllerCreateGifFromAssets>>,
  TError,
  { orgId: string; clientId: string; data: CreateGifFromAssetsDto },
  TContext
> => {
  const mutationOptions = getMediaLibraryControllerCreateGifFromAssetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Remove background from an image asset and create a new cutout asset
 */
export const mediaLibraryControllerRemoveBackground = (
  orgId: string,
  clientId: string,
  id: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MediaAssetDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}/media/assets/${id}/remove-background`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getMediaLibraryControllerRemoveBackgroundMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mediaLibraryControllerRemoveBackground>>,
    TError,
    { orgId: string; clientId: string; id: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mediaLibraryControllerRemoveBackground>>,
  TError,
  { orgId: string; clientId: string; id: string },
  TContext
> => {
  const mutationKey = ['mediaLibraryControllerRemoveBackground'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mediaLibraryControllerRemoveBackground>>,
    { orgId: string; clientId: string; id: string }
  > = (props) => {
    const { orgId, clientId, id } = props ?? {};

    return mediaLibraryControllerRemoveBackground(orgId, clientId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MediaLibraryControllerRemoveBackgroundMutationResult = NonNullable<
  Awaited<ReturnType<typeof mediaLibraryControllerRemoveBackground>>
>;

export type MediaLibraryControllerRemoveBackgroundMutationError = unknown;

/**
 * @summary Remove background from an image asset and create a new cutout asset
 */
export const useMediaLibraryControllerRemoveBackground = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mediaLibraryControllerRemoveBackground>>,
      TError,
      { orgId: string; clientId: string; id: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mediaLibraryControllerRemoveBackground>>,
  TError,
  { orgId: string; clientId: string; id: string },
  TContext
> => {
  const mutationOptions = getMediaLibraryControllerRemoveBackgroundMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Remove background from an image URL and return the cutout URL
 */
export const mediaLibraryControllerRemoveBackgroundFromUrl = (
  orgId: string,
  clientId: string,
  removeBackgroundDto: RemoveBackgroundDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<RemoveBackgroundResponseDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}/media/remove-background`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: removeBackgroundDto,
      signal,
    },
    options
  );
};

export const getMediaLibraryControllerRemoveBackgroundFromUrlMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mediaLibraryControllerRemoveBackgroundFromUrl>>,
    TError,
    { orgId: string; clientId: string; data: RemoveBackgroundDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mediaLibraryControllerRemoveBackgroundFromUrl>>,
  TError,
  { orgId: string; clientId: string; data: RemoveBackgroundDto },
  TContext
> => {
  const mutationKey = ['mediaLibraryControllerRemoveBackgroundFromUrl'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mediaLibraryControllerRemoveBackgroundFromUrl>>,
    { orgId: string; clientId: string; data: RemoveBackgroundDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return mediaLibraryControllerRemoveBackgroundFromUrl(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MediaLibraryControllerRemoveBackgroundFromUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof mediaLibraryControllerRemoveBackgroundFromUrl>>
>;
export type MediaLibraryControllerRemoveBackgroundFromUrlMutationBody = RemoveBackgroundDto;
export type MediaLibraryControllerRemoveBackgroundFromUrlMutationError = unknown;

/**
 * @summary Remove background from an image URL and return the cutout URL
 */
export const useMediaLibraryControllerRemoveBackgroundFromUrl = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mediaLibraryControllerRemoveBackgroundFromUrl>>,
      TError,
      { orgId: string; clientId: string; data: RemoveBackgroundDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mediaLibraryControllerRemoveBackgroundFromUrl>>,
  TError,
  { orgId: string; clientId: string; data: RemoveBackgroundDto },
  TContext
> => {
  const mutationOptions = getMediaLibraryControllerRemoveBackgroundFromUrlMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Calls the puppet service to convert a raster image (URL) into an SVG with one or more colored paths. Pass through tracer params (colorMode, mode, filterSpeckle, etc.) on the request body.
 * @summary Vectorize a raster image into an SVG document
 */
export const mediaLibraryControllerVectorizeImage = (
  orgId: string,
  clientId: string,
  vectorizeImageDto: VectorizeImageDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<VectorizeImageResponseDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}/media/vectorize`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: vectorizeImageDto,
      signal,
    },
    options
  );
};

export const getMediaLibraryControllerVectorizeImageMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mediaLibraryControllerVectorizeImage>>,
    TError,
    { orgId: string; clientId: string; data: VectorizeImageDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mediaLibraryControllerVectorizeImage>>,
  TError,
  { orgId: string; clientId: string; data: VectorizeImageDto },
  TContext
> => {
  const mutationKey = ['mediaLibraryControllerVectorizeImage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mediaLibraryControllerVectorizeImage>>,
    { orgId: string; clientId: string; data: VectorizeImageDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return mediaLibraryControllerVectorizeImage(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MediaLibraryControllerVectorizeImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof mediaLibraryControllerVectorizeImage>>
>;
export type MediaLibraryControllerVectorizeImageMutationBody = VectorizeImageDto;
export type MediaLibraryControllerVectorizeImageMutationError = unknown;

/**
 * @summary Vectorize a raster image into an SVG document
 */
export const useMediaLibraryControllerVectorizeImage = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mediaLibraryControllerVectorizeImage>>,
      TError,
      { orgId: string; clientId: string; data: VectorizeImageDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mediaLibraryControllerVectorizeImage>>,
  TError,
  { orgId: string; clientId: string; data: VectorizeImageDto },
  TContext
> => {
  const mutationOptions = getMediaLibraryControllerVectorizeImageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get all collections for a client
 */
export const mediaLibraryControllerGetCollections = (
  orgId: string,
  clientId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<GetCollectionsResponseDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}/media/collections`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getMediaLibraryControllerGetCollectionsQueryKey = (
  orgId?: string,
  clientId?: string
) => {
  return [`/api/organizations/${orgId}/clients/${clientId}/media/collections`] as const;
};

export const getMediaLibraryControllerGetCollectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetCollections>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof mediaLibraryControllerGetCollections>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMediaLibraryControllerGetCollectionsQueryKey(orgId, clientId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof mediaLibraryControllerGetCollections>>
  > = ({ signal }) => mediaLibraryControllerGetCollections(orgId, clientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof mediaLibraryControllerGetCollections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MediaLibraryControllerGetCollectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof mediaLibraryControllerGetCollections>>
>;
export type MediaLibraryControllerGetCollectionsQueryError = unknown;

export function useMediaLibraryControllerGetCollections<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetCollections>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof mediaLibraryControllerGetCollections>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaLibraryControllerGetCollections>>,
          TError,
          Awaited<ReturnType<typeof mediaLibraryControllerGetCollections>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMediaLibraryControllerGetCollections<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetCollections>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof mediaLibraryControllerGetCollections>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaLibraryControllerGetCollections>>,
          TError,
          Awaited<ReturnType<typeof mediaLibraryControllerGetCollections>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMediaLibraryControllerGetCollections<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetCollections>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof mediaLibraryControllerGetCollections>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get all collections for a client
 */

export function useMediaLibraryControllerGetCollections<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetCollections>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof mediaLibraryControllerGetCollections>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMediaLibraryControllerGetCollectionsQueryOptions(
    orgId,
    clientId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new collection
 */
export const mediaLibraryControllerCreateCollection = (
  orgId: string,
  clientId: string,
  createCollectionDto: CreateCollectionDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MediaCollectionDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}/media/collections`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createCollectionDto,
      signal,
    },
    options
  );
};

export const getMediaLibraryControllerCreateCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mediaLibraryControllerCreateCollection>>,
    TError,
    { orgId: string; clientId: string; data: CreateCollectionDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mediaLibraryControllerCreateCollection>>,
  TError,
  { orgId: string; clientId: string; data: CreateCollectionDto },
  TContext
> => {
  const mutationKey = ['mediaLibraryControllerCreateCollection'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mediaLibraryControllerCreateCollection>>,
    { orgId: string; clientId: string; data: CreateCollectionDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return mediaLibraryControllerCreateCollection(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MediaLibraryControllerCreateCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof mediaLibraryControllerCreateCollection>>
>;
export type MediaLibraryControllerCreateCollectionMutationBody = CreateCollectionDto;
export type MediaLibraryControllerCreateCollectionMutationError = unknown;

/**
 * @summary Create a new collection
 */
export const useMediaLibraryControllerCreateCollection = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mediaLibraryControllerCreateCollection>>,
      TError,
      { orgId: string; clientId: string; data: CreateCollectionDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mediaLibraryControllerCreateCollection>>,
  TError,
  { orgId: string; clientId: string; data: CreateCollectionDto },
  TContext
> => {
  const mutationOptions = getMediaLibraryControllerCreateCollectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get a single collection
 */
export const mediaLibraryControllerGetCollection = (
  orgId: string,
  clientId: string,
  id: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MediaCollectionDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}/media/collections/${id}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getMediaLibraryControllerGetCollectionQueryKey = (
  orgId?: string,
  clientId?: string,
  id?: string
) => {
  return [`/api/organizations/${orgId}/clients/${clientId}/media/collections/${id}`] as const;
};

export const getMediaLibraryControllerGetCollectionQueryOptions = <
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetCollection>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof mediaLibraryControllerGetCollection>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMediaLibraryControllerGetCollectionQueryKey(orgId, clientId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaLibraryControllerGetCollection>>> = ({
    signal,
  }) => mediaLibraryControllerGetCollection(orgId, clientId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && clientId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof mediaLibraryControllerGetCollection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MediaLibraryControllerGetCollectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof mediaLibraryControllerGetCollection>>
>;
export type MediaLibraryControllerGetCollectionQueryError = unknown;

export function useMediaLibraryControllerGetCollection<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetCollection>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof mediaLibraryControllerGetCollection>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaLibraryControllerGetCollection>>,
          TError,
          Awaited<ReturnType<typeof mediaLibraryControllerGetCollection>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMediaLibraryControllerGetCollection<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetCollection>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof mediaLibraryControllerGetCollection>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaLibraryControllerGetCollection>>,
          TError,
          Awaited<ReturnType<typeof mediaLibraryControllerGetCollection>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMediaLibraryControllerGetCollection<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetCollection>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof mediaLibraryControllerGetCollection>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single collection
 */

export function useMediaLibraryControllerGetCollection<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetCollection>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof mediaLibraryControllerGetCollection>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMediaLibraryControllerGetCollectionQueryOptions(
    orgId,
    clientId,
    id,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update collection
 */
export const mediaLibraryControllerUpdateCollection = (
  orgId: string,
  clientId: string,
  id: string,
  updateCollectionDto: UpdateCollectionDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<MediaCollectionDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}/media/collections/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateCollectionDto,
    },
    options
  );
};

export const getMediaLibraryControllerUpdateCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mediaLibraryControllerUpdateCollection>>,
    TError,
    { orgId: string; clientId: string; id: string; data: UpdateCollectionDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mediaLibraryControllerUpdateCollection>>,
  TError,
  { orgId: string; clientId: string; id: string; data: UpdateCollectionDto },
  TContext
> => {
  const mutationKey = ['mediaLibraryControllerUpdateCollection'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mediaLibraryControllerUpdateCollection>>,
    { orgId: string; clientId: string; id: string; data: UpdateCollectionDto }
  > = (props) => {
    const { orgId, clientId, id, data } = props ?? {};

    return mediaLibraryControllerUpdateCollection(orgId, clientId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MediaLibraryControllerUpdateCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof mediaLibraryControllerUpdateCollection>>
>;
export type MediaLibraryControllerUpdateCollectionMutationBody = UpdateCollectionDto;
export type MediaLibraryControllerUpdateCollectionMutationError = unknown;

/**
 * @summary Update collection
 */
export const useMediaLibraryControllerUpdateCollection = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mediaLibraryControllerUpdateCollection>>,
      TError,
      { orgId: string; clientId: string; id: string; data: UpdateCollectionDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mediaLibraryControllerUpdateCollection>>,
  TError,
  { orgId: string; clientId: string; id: string; data: UpdateCollectionDto },
  TContext
> => {
  const mutationOptions = getMediaLibraryControllerUpdateCollectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete collection
 */
export const mediaLibraryControllerDeleteCollection = (
  orgId: string,
  clientId: string,
  id: string,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<SuccessResponseDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}/media/collections/${id}`,
      method: 'DELETE',
    },
    options
  );
};

export const getMediaLibraryControllerDeleteCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mediaLibraryControllerDeleteCollection>>,
    TError,
    { orgId: string; clientId: string; id: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mediaLibraryControllerDeleteCollection>>,
  TError,
  { orgId: string; clientId: string; id: string },
  TContext
> => {
  const mutationKey = ['mediaLibraryControllerDeleteCollection'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mediaLibraryControllerDeleteCollection>>,
    { orgId: string; clientId: string; id: string }
  > = (props) => {
    const { orgId, clientId, id } = props ?? {};

    return mediaLibraryControllerDeleteCollection(orgId, clientId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MediaLibraryControllerDeleteCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof mediaLibraryControllerDeleteCollection>>
>;

export type MediaLibraryControllerDeleteCollectionMutationError = unknown;

/**
 * @summary Delete collection
 */
export const useMediaLibraryControllerDeleteCollection = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mediaLibraryControllerDeleteCollection>>,
      TError,
      { orgId: string; clientId: string; id: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mediaLibraryControllerDeleteCollection>>,
  TError,
  { orgId: string; clientId: string; id: string },
  TContext
> => {
  const mutationOptions = getMediaLibraryControllerDeleteCollectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get all assets in a collection
 */
export const mediaLibraryControllerGetCollectionAssets = (
  orgId: string,
  clientId: string,
  id: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<CollectionAssetsResponseDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}/media/collections/${id}/assets`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getMediaLibraryControllerGetCollectionAssetsQueryKey = (
  orgId?: string,
  clientId?: string,
  id?: string
) => {
  return [
    `/api/organizations/${orgId}/clients/${clientId}/media/collections/${id}/assets`,
  ] as const;
};

export const getMediaLibraryControllerGetCollectionAssetsQueryOptions = <
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetCollectionAssets>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof mediaLibraryControllerGetCollectionAssets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getMediaLibraryControllerGetCollectionAssetsQueryKey(orgId, clientId, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof mediaLibraryControllerGetCollectionAssets>>
  > = ({ signal }) =>
    mediaLibraryControllerGetCollectionAssets(orgId, clientId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && clientId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof mediaLibraryControllerGetCollectionAssets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MediaLibraryControllerGetCollectionAssetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof mediaLibraryControllerGetCollectionAssets>>
>;
export type MediaLibraryControllerGetCollectionAssetsQueryError = unknown;

export function useMediaLibraryControllerGetCollectionAssets<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetCollectionAssets>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof mediaLibraryControllerGetCollectionAssets>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaLibraryControllerGetCollectionAssets>>,
          TError,
          Awaited<ReturnType<typeof mediaLibraryControllerGetCollectionAssets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMediaLibraryControllerGetCollectionAssets<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetCollectionAssets>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof mediaLibraryControllerGetCollectionAssets>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaLibraryControllerGetCollectionAssets>>,
          TError,
          Awaited<ReturnType<typeof mediaLibraryControllerGetCollectionAssets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMediaLibraryControllerGetCollectionAssets<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetCollectionAssets>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof mediaLibraryControllerGetCollectionAssets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get all assets in a collection
 */

export function useMediaLibraryControllerGetCollectionAssets<
  TData = Awaited<ReturnType<typeof mediaLibraryControllerGetCollectionAssets>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof mediaLibraryControllerGetCollectionAssets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMediaLibraryControllerGetCollectionAssetsQueryOptions(
    orgId,
    clientId,
    id,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add assets to collection
 */
export const mediaLibraryControllerAddAssetsToCollection = (
  orgId: string,
  clientId: string,
  id: string,
  addAssetsToCollectionDto: AddAssetsToCollectionDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<SuccessResponseDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}/media/collections/${id}/assets`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: addAssetsToCollectionDto,
      signal,
    },
    options
  );
};

export const getMediaLibraryControllerAddAssetsToCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mediaLibraryControllerAddAssetsToCollection>>,
    TError,
    { orgId: string; clientId: string; id: string; data: AddAssetsToCollectionDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mediaLibraryControllerAddAssetsToCollection>>,
  TError,
  { orgId: string; clientId: string; id: string; data: AddAssetsToCollectionDto },
  TContext
> => {
  const mutationKey = ['mediaLibraryControllerAddAssetsToCollection'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mediaLibraryControllerAddAssetsToCollection>>,
    { orgId: string; clientId: string; id: string; data: AddAssetsToCollectionDto }
  > = (props) => {
    const { orgId, clientId, id, data } = props ?? {};

    return mediaLibraryControllerAddAssetsToCollection(orgId, clientId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MediaLibraryControllerAddAssetsToCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof mediaLibraryControllerAddAssetsToCollection>>
>;
export type MediaLibraryControllerAddAssetsToCollectionMutationBody = AddAssetsToCollectionDto;
export type MediaLibraryControllerAddAssetsToCollectionMutationError = unknown;

/**
 * @summary Add assets to collection
 */
export const useMediaLibraryControllerAddAssetsToCollection = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mediaLibraryControllerAddAssetsToCollection>>,
      TError,
      { orgId: string; clientId: string; id: string; data: AddAssetsToCollectionDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mediaLibraryControllerAddAssetsToCollection>>,
  TError,
  { orgId: string; clientId: string; id: string; data: AddAssetsToCollectionDto },
  TContext
> => {
  const mutationOptions = getMediaLibraryControllerAddAssetsToCollectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Remove asset from collection
 */
export const mediaLibraryControllerRemoveAssetFromCollection = (
  orgId: string,
  clientId: string,
  id: string,
  assetId: string,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<SuccessResponseDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}/media/collections/${id}/assets/${assetId}`,
      method: 'DELETE',
    },
    options
  );
};

export const getMediaLibraryControllerRemoveAssetFromCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mediaLibraryControllerRemoveAssetFromCollection>>,
    TError,
    { orgId: string; clientId: string; id: string; assetId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mediaLibraryControllerRemoveAssetFromCollection>>,
  TError,
  { orgId: string; clientId: string; id: string; assetId: string },
  TContext
> => {
  const mutationKey = ['mediaLibraryControllerRemoveAssetFromCollection'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mediaLibraryControllerRemoveAssetFromCollection>>,
    { orgId: string; clientId: string; id: string; assetId: string }
  > = (props) => {
    const { orgId, clientId, id, assetId } = props ?? {};

    return mediaLibraryControllerRemoveAssetFromCollection(
      orgId,
      clientId,
      id,
      assetId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type MediaLibraryControllerRemoveAssetFromCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof mediaLibraryControllerRemoveAssetFromCollection>>
>;

export type MediaLibraryControllerRemoveAssetFromCollectionMutationError = unknown;

/**
 * @summary Remove asset from collection
 */
export const useMediaLibraryControllerRemoveAssetFromCollection = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mediaLibraryControllerRemoveAssetFromCollection>>,
      TError,
      { orgId: string; clientId: string; id: string; assetId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mediaLibraryControllerRemoveAssetFromCollection>>,
  TError,
  { orgId: string; clientId: string; id: string; assetId: string },
  TContext
> => {
  const mutationOptions =
    getMediaLibraryControllerRemoveAssetFromCollectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
